import {Base64File} from 'types';
const mime = require('mime');

const buildDownloadStr = ({fileName, data} :Base64File) :string => {
    return `data:${mime.getType(fileName)};base64,${data}`
}

export default {buildDownloadStr}